export const splitName = (name: string) => {
  let fileName = name;
  if (fileName.length >= 18) {
    let limitName = fileName.split('.');
    fileName = limitName[0].substring(0, 18) + '... .' + limitName[1];
    return fileName;
  }
  return name;
};